import React from 'react';
import classnames from 'classnames';
import SimpleThread from '../SimpleThread';
import { ThreadProps } from '../../types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './CardLayoutThread.scss';

const CardLayoutThread: React.FC<ThreadProps> = props => {
  const is_exclusive_avatar = useFlag('exclusive_avatars');
  return (
    <SimpleThread
      {...props}
      className={classnames(s['card-layout'], props.className)}
      commentBoxWrapperClassName={classnames(
        s['commentbox-wrapper'],
        is_exclusive_avatar && s['exclusive-avatar']
      )}
      threadStackClassName={s['thread-stack']}
      headerClassName={s['header']}
      scrollableClassName={s['scrollable']}
      replyIndentModifier={0}
    />
  );
};
CardLayoutThread.displayName = 'CardLayoutThread';

export default CardLayoutThread;
